const colors = {
  button: {
    primary: {
      active: '#10AC84',
      disabled: '#c8d6e5'
    },
    secondary: {
      active: '#222f3e'
    },
    edit: {
      hover: '#8B572A'
    }
  },
  background: {
    primary: '#F2F4F7',
    primary_hover: '#E5E7EA',
    footerBackground: 'rgb(87, 101, 116)',
    inputs: '#F1F4F7'
  },
  icons: {
    blue: '#2E86DE'
  },
  border: {
    primary: '#C8D6E5',
    primary_hover: '#AFBDCC',
    secondary: '#2875c3',
    tertiary: '#2875C3'
  },
  text: {
    primary: '#11181F',
    secondary: '#576574',
    accent: '#0FAC84',
    link: '#2875c3',
    lightGray: '#C8D6E5',
    lightGray2: '#8395A7',
    darkBlue: '#2875C3'
  },
  error: {
    primary: '#EE5253'
  },
  primary: '#10AC84',
  secondary: '#2875c3',
  white: '#FFFFFF'
};
export default colors;
